import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { imageStyles } from './styles/image.styles';
import type { ImagePropsInterface } from './types/image.types';

/**
 * A simple `img` tag.
 *
 * @since 6.10.0
 */
export const Image = forwardRef<HTMLImageElement, ImagePropsInterface>(
  (props: ImagePropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;

    const styles = css(imageStyles, cssProp);

    const Component = asChild ? Slot : 'img';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Image"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

Image.displayName = 'Image';
